import { createAppKit } from '@reown/appkit';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { networks } from './configs';
export class AppKitInitializer {
    modal;
    config;
    constructor(initInputData) {
        const { modal, config } = this.init(initInputData);
        this.modal = modal;
        this.config = config;
    }
    init({ chains, metadata, node, projectId, features = {} }) {
        const networks = this.configureNetworks(chains, node);
        const wagmiAdapter = new WagmiAdapter({
            projectId,
            networks,
        });
        const config = wagmiAdapter.wagmiConfig;
        const modal = createAppKit({
            adapters: [wagmiAdapter],
            networks,
            metadata,
            projectId,
            features: {
                allWallets: true,
                onramp: true,
                analytics: false,
                email: false,
                emailShowWallets: false,
                history: false,
                socials: false,
                swaps: false,
                ...features,
            },
        });
        return { modal, config };
    }
    configureNetworks(requestedNetworks, node) {
        const configuredNetworks = requestedNetworks.reduce((acc, requestedNetwork) => {
            if (networks[requestedNetwork]) {
                acc.push(networks[requestedNetwork](node));
            }
            return acc;
        }, []);
        if (configuredNetworks.length === 0) {
            // Sentry.captureMessage('No networks provided'); // Inject Sentry? @hawaiih take it
            throw new Error('No networks provided');
        }
        return configuredNetworks;
    }
}
